import { useCallback } from 'react';
import { CollapseAndFade } from '@buoyhealth/common.buoy-layout';
import styled from 'styled-components';
import Typewriter, { TypewriterClass } from 'typewriter-effect';

const Container = styled.div`
  .Typewriter {
    ${({ theme }) => theme.typography.variants.primary.main};

    p {
      margin-top: 10px;
    }
  }
`;

const TypewriterLoadingMessage = ({
  onTypewriterStop,
  loadingMessage,
}: {
  onTypewriterStop?: () => void;
  loadingMessage: string;
}) => {
  const initTypewriter = useCallback((typewriter: TypewriterClass) => {
    typewriter
      .pauseFor(1000)
      .typeString(loadingMessage)
      .pauseFor(1000)
      .typeString(' This may take several seconds...')
      .callFunction(() => {
        onTypewriterStop?.();
      })
      .start();
  }, []);

  return (
    <Container className="BuoyInterviews__TypewriterLoadingMessage">
      <CollapseAndFade show enter>
        <Typewriter
          onInit={initTypewriter}
          options={{
            delay: 18,
            deleteSpeed: 10,
          }}
        />
      </CollapseAndFade>
    </Container>
  );
};

export default TypewriterLoadingMessage;
